import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsjumbotron',
	templateUrl:'./BSJumbotronPluginCompPage.html',
	styles: [],
	styleUrls:['./BSJumbotronPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSJumbotronPluginCompPage
{
	mdContent_828 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.jumbotron.BSJumbotron;
\`\`\``;
	mdContent_829 = `\`\`\`java
BSJumbotron()
\`\`\``;
	mdContent_830 = `\`\`\`java
BSJumbotron&lt;?&gt; jumbo = new BSJumbotron&lt;&gt;();
jumbo.add(new H1&lt;&gt;().setText("Welcome!"));
jumbo.add(new Paragraph&lt;&gt;().setText("This is a hero section."));
jumbo.setFluid(true);
\`\`\``;
}
